import React, { useState, useRef, useEffect,useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faApple,
  faGooglePlay,
} from "@fortawesome/free-brands-svg-icons";
import axios from 'axios';

import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./Menu/global";
import { theme } from ".//Menu/theme";
import Typed from 'react-typed';
import { Helmet } from "react-helmet";

import Fade from "react-reveal/Fade";
import { Formik } from "formik";
import {Link} from 'react-router-dom'
import { Link  as Link1} from "react-scroll";

import "animate.css/animate.css";
import Menu from "./Menu/Menu";
import Burger from "./Menu/Burger";



function Home() {


  // style
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const [thank,setThank]= useState(false);
  const [error,setError]= useState(false);

  const headerRef = useRef(null);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };
// scroll to the section by updating url 
const [isLoading, setIsLoading] = useState(true);


useEffect(
  () => {
    var currentUrl = window.location.hash
    if(isLoading){
      if(currentUrl!=="") {
console.log('ffffff')
return( 
  
  window.scrollTo({
  behavior: "smooth",
  top: document.getElementById(currentUrl.replace("#", "")).offsetTop
}))
       
      }   else{
  
        return
      }

    }

  },
  [isLoading]
  );


  // add/remove scroll event listener
  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, []);

  // router
  function handleClick(e, path) {
    e.preventDefault();
    window.open(path, '_blank') 
  }

  // send data
  const initialValues = {
    name: "",
    phone: "",
    email: "",
    msg: "",
  };
  const validate = (values) => {
    let errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const regexName = /\d/
    const regexPhone = /^[0-9]*$/

    if (!values.email) {
      errors.email = "Email is required";
    } else if (!regex.test(values.email)) {
      errors.email = "Invalid Email";
    }
    if (!values.name) {
      errors.name = "Name is required";
    } else if (regexName.test(values.name)==true) {
      errors.name = "Invalid Name";
    }
    if (!values.phone) {
      errors.phone = "Phone is required";
    } else if (!regexPhone.test(values.phone)) {
      errors.phone = "Invalid Phone";
    }
    if (!values.msg) {
      errors.msg = "Message is required";
    } 
    return errors;
  };

  const submitForm = async (values , actions) => {
    console.log(document.querySelector('[type="submit"]')[0])
    document.querySelector('[type="submit"]').classList.add("disabled-btn")

    let response = await  axios.post(`http://178.79.135.126:5433/guest/guest_contact_us`, { 
     name:values.name,
        email:values.email,
        phone:values.phone,
       message:values.msg   
     })
    .then(res => {
      
      document.querySelector('[type="submit"]').classList.remove("disabled-btn")

      actions.resetForm({
        values: {
          name: "",
          phone: "",
          email: "",
          msg: "",
         }
        })
        setThank(true)
    })
    .catch((err)=>{
        setError(true)  
        document.querySelector('[type="submit"]').classList.remove("disabled-btn")
    
  
      

    }
      
    )




  };


  
  return (
    <div>

<Helmet>
                <meta charSet="utf-8" />
                <title>Nos-Wazeefa </title>
                <link
                  rel="canonical"
                  href="http://noswazeefa.net/"
                />
            </Helmet>
  
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />

        <div className='english'>
          <div id="menu_mobile">
            <Burger open={open} setOpen={setOpen} />
            <Menu open={open} setOpen={setOpen} />
          </div>
          <header id="Home">
            <nav
              id="sticky-header"
              className={`navbar${sticky.isSticky ? " sticky" : "notsticky"}`}
              ref={headerRef}
            >
              <div>
                <div className="logo">
                  <img src={require("../assets/images/logo.png")} alt="logo" />
                </div>
                <div className="list">
                  <ul>
                    <li>
                      <Link1
                        to="Home"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Home
                      </Link1>
                    </li>
                    <li>
                      <Link1
                        to="Features"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Download the App
                      </Link1>
                    </li>

                    <li>
                      <Link1
                        to="Company"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Company Website
                      </Link1>
                    </li>
                    <li>
                      <Link
                        to="/privacy"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Privacy&Policy
                      </Link>
                    </li>
                    <li>
                      <Link1
                        to="Contact"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Contact
                      </Link1>
                    </li>
                    <li>
                    <Link  rel="canonical" to="/ar" className="ar" >
                        العربيه
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <div className="header_left">
              <h2>
               Nos Wazeefa
               

               <span>   <Typed
                    strings={['where our Saudi talented promoters and Saudi Companies meet.']}
                    typeSpeed={40} 
                    startDelay={200}
                />
                </span>
              </h2>

              <p className="img animate__fadeInLeft icon animated  animate__animated animate__delay-1s  ">
                Hiring just got easier than ever!
                <br />
                <br />
                Hiring has just got easier than ever before. Sign-up today
                through Nos-Wazeefa website. Build your company’s profile, and
                Start an exciting recruitment process.Here is the ultimate
                solution for your needs!!{" "}
              </p>
              <div className="download_btn">
                <button>
                  <a href={process.env.PUBLIC_URL +('nos_wazeefa_english_company_profile.pdf')} download>
                  <FontAwesomeIcon icon={faDownload} />
                  <span>
                    <span>Download</span>
                    <br />
                    Our Profile
                  </span>
                  </a>
                </button>
                <button onClick= {(e) =>
                    handleClick(
                      e,
                      "http://company.noswazeefa.net/#/"
                    )
                  }>
                  <span>
                    <span>Today</span>
                    <br />
                    Sign Up
                  </span>{" "}
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
            <div className="header_right img animate__fadeInRight icon animated  animate__animated  animate__delay-1s">
              <div className="img  icon ">
  
              </div>

              <img
                className=" animate__fadeIn icon animated  animate__animated animate__delay-1s  "
                src={require("../assets/images/hder_mobile_img.png")}
              />

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </header>

          <main>
            <section
              data-aos="fade-up"
              data-aos-duration="3000"
              className="features"
              id="Features"
              name="Features"
            >
              <div className="text">
                <Fade>
                  <h3>Looking for a perfect part-time job?</h3>
                </Fade>
                <Fade bottom>
                  <p>
                    Download Nos-Wazeefa application now, and discover great job
                    opportunities matching your skills and experience.
                  </p>
               
                  <div className="buttons apple_google">
                    <button
                      onClick={(e) =>
                        handleClick(
                          e,
                          "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                        )
                      }
                    >
                      {/* <span>
                        {" "}
                        <span>أحصل عليه من </span> <br />متجر جوجل
                      </span>
                      <FontAwesomeIcon icon={faGooglePlay} /> */}
                                        <img src={require("../assets/images/google.png")} alt=''/>


                    </button>
                    <button
                      onClick={(e) =>
                        handleClick(
                          e,
                          "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                        )
                      }
                    >
                      {/* <span>
                        <span>أحصل عليه من</span> <br />
                        متجر آبل
                                         
                                              </span>
                                              <FontAwesomeIcon icon={faApple} /> */}
                             <img src={require("../assets/images/apple.png")} alt=''/>


                    </button>
                  </div>
                </Fade>
              </div>
              <img src={require("../assets/images/featuresImgen.png")} />

              <svg width="0" height="0">
                <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                  <stop stopColor="#115db4" offset="0" />
                  <stop stopColor="#f58220" offset="1" />
                </radialGradient>
              </svg>
              <Fade bottom>
                <div className="grid">
                  <div>
                    <figure>
                      <img src={require("../assets/images/cv.png")} />
                    </figure>
                    <figcaption>Create your account</figcaption>
                  </div>
                  <div>
                    <figure>
                      <img src={require("../assets/images/bag.png")} />
                    </figure>
                    <figcaption>Build your resume</figcaption>
                  </div>{" "}
                  <div>
                    <figure>
                      <img src={require("../assets/images/lens.png")} />
                    </figure>
                    <figcaption>Apply for the suitable jobs</figcaption>
                  </div>{" "}
                  <div>
                    <figure>
                      <img src={require("../assets/images/hand.png")} />
                    </figure>
                    <figcaption>Accept or reject new job offers</figcaption>
                  </div>
                </div>
              </Fade>
            </section>
          </main>
          <Fade>
            <h3>OUR STATICS</h3>
          </Fade>

          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="static"
          >
            <div className="grid">
              <div>
                <img src={require("../assets/images/employee.png")} />

                <h4>
                  {" "}
                  <CountUp end={4687} start={1000} delay={5} duration={10} />
                </h4>

                <h4>users</h4>
              </div>
              <div>
                <img src={require("../assets/images/downarrow.png")} />
                <h4>
                  {" "}
                  <CountUp end={500} start={0} delay={5} duration={10} />k
                </h4>

                <h4>Download</h4>
              </div>
              <div>
                <img src={require("../assets/images/verified.png")} />
                <h4>
                  {" "}
                  <CountUp end={750} start={0} delay={5} duration={8} />
                </h4>

                <h4>Sepervisors</h4>
              </div>
              <div>
                <img src={require("../assets/images/5stars.png")} />
                <h4>
                  {" "}
                  <CountUp end={3000} start={100} delay={5} duration={10} />
                </h4>

                <h4>5 Star Rating</h4>
              </div>
            </div>
          </section>
          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="company"
            id="Company"
            name="Company"
          >
            <Fade>
              <h3>Company Website</h3>
            </Fade>
            <div className="flex">
              <Fade left>
                <div>
                  <img src={require("../assets/images/tablet.png")} />
                </div>
              </Fade>
              <Fade right>
                <ul>
                  <li>
                    {" "}
                    <img
                      className="icon animated  animate__animated   animate__infinite	infinite"
                      src={require("../assets/images/cloud-computing.png")}
                    />
                    <span>Build Your Company profile</span>
                  </li>
                  <li>
                    {" "}
                    <img
                      className="icon"
                      src={require("../assets/images/badge.png")}
                    />
                    <span>Post your first job/ project</span>
                  </li>

                  <li>
                    {" "}
                    <img
                      className="icon"
                      src={require("../assets/images/profile.png")}
                    />
                    <span>Choose between thousands of Saudi promoters</span>
                  </li>

                  <li>
                    <img
                      className="icon"
                      src={require("../assets/images/computer.png")}
                    />
                    <span>Accept/ reject promoters’ applications.</span>
                  </li>
                  <li>
                    <button className="button" onClick={(e) =>
                    handleClick(
                      e,
                      "http://company.noswazeefa.net/#/"
                    )
                  } >
                      
                      <span>
                        Discover More <FontAwesomeIcon icon={faChevronRight} />{" "}
                      </span>
                    </button>
                  </li>
                </ul>
              </Fade>
            </div>
          </section>


          { (thank==false && error==false) &&
          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="contact"
            id="Contact"
          >
            <Fade bottom>
              <h5>Need a quick consultation through our professional team?</h5>
            </Fade>
            <Fade bottom>
              <h4>Contact us today, and we will reply your request shortly.</h4>
            </Fade>
            <Fade>
            <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={submitForm}
    >
      {(formik) => {
        const {
          values,
          handleChange,
          handleSubmit,
          errors,
          touched,
          handleBlur,
          isValid,
          dirty
        } = formik;
  return (
              <form onSubmit={handleSubmit}>
                <div>
                  <div>
                  <input
                    placeholder='Name'
                   type="text"
                   name="name"
                   id="name"
                   value={values.name}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.name && touched.name ? 
                   "input-error" : null}
                />
 {errors.name && touched.name && (
                    <span className="error">{errors.name}</span>
                  )}
</div>
                  <br />
                  <div>

                  <input
                   type="phone"
                   name="phone"
                   id="phone"
                    placeholder='Phone Number'
                   value={values.phone}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.phone && touched.phone ? 
                   "input-error" : null}
                />
 {errors.phone && touched.phone && (
                    <span className="error">{errors.phone}</span>
                  )}
</div>
                  <br />
                </div>
                <input
                                    placeholder='Email'

                   type="email"
                   name="email"
                   id="email"
                   value={values.email}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.email && touched.email ? 
                   "input-error" : null}
                />
 {errors.email && touched.email && (
                    <span className="error">{errors.email}</span>
                  )}
                <textarea
                                                    placeholder='Message'

                   type="text"
                   name="msg"
                   id="msg"
                   value={values.msg}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.msg && touched.msg ? 
                   "input-error" : null}
                />
 {errors.msg && touched.msg && (
                    <span className="error">{errors.msg}</span>
                  )}

                <br />
                <button  type="submit"
                  className={dirty && isValid ? "button" : "button disabled-btn"}
                  disabled={!(dirty && isValid)}>
                  {" "}
                  <span>
                    Send Message <FontAwesomeIcon icon={faChevronRight} />
                  </span>
                </button>
              </form>
     
     
     );
    }}
         </Formik>       
         </Fade>
          </section>

        }


{ (thank==true&&error==false) &&

  <section id="result" className="animate__zoomIn  animated  animate__animated">
<img src={require("../assets/images/resulticon.png")} alt=''/>
<p className="grdtxt">Thank You For Connecting US</p>
<p>we'll reach you out immediately!</p>
</section>

}
{ (thank==false&&error==true) &&

<section id="result" className="animate__zoomIn  animated  animate__animated">
<img src={require("../assets/images/error.png")} alt=''/>
<p className="grdtxt">SORRY !</p>
<p>Looks like something wrong Please try again later!</p>
</section>

}






          <footer>
            <div>
            <Fade bottom>
              <h4>
                Download our App Today & <br /> Experience Endless Possibilities
              </h4>
              </Fade>
              <div className="buttons apple_google">
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                    )
                  }
                >
                  {/* <span>
                    {" "}
                    <span>   أحصل عليه </span>
                 
                
                     <br />     من متجر آبل 
                  </span>
                  <FontAwesomeIcon icon={faGooglePlay} /> */}
                                    <img src={require("../assets/images/google.png")} alt=''/>


                </button>
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                    )
                  }
                >

                  <img src={require("../assets/images/apple.png")} alt=''/>

                </button>
              </div>
            </div>

            <div className="bot_page">
              <p>
                © copyright 2020 | All right reserved.Developed by{" "}
                <span>
                  <a href="https://natsaudi.net/" target="_blank">NAT</a>
                </span>{" "}
                | <Link  rel="canonical" to="/privacy">Privacy&Policy</Link>
              </p>

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </>
    </ThemeProvider>
 
    </div>
 
  );
}
export default Home;
